// extracted by mini-css-extract-plugin
export default {"shape":"challenge-bubble_shape__0Zd18","bubbleGrey":"challenge-bubble_bubbleGrey__tnN-b","bubbleBlue":"challenge-bubble_bubbleBlue__laiM6"};